import { Injectable } from '@angular/core';
import { SESSION_STORAGE_KEY } from '../../features/auth/shared/auth-state';

@Injectable({ providedIn: 'root' })
export class TokenService {
  getAccessToken(): string | null {
    try {
      const raw = localStorage.getItem(SESSION_STORAGE_KEY);
      if (!raw) return null;
      return (JSON.parse(raw) as { accessToken?: string | null }).accessToken ?? null;
    } catch {
      return null;
    }
  }
}
